/* global axios */
import ApiClient from './ApiClient';

class PipelineAutomationsAPI extends ApiClient {
  constructor() {
    // Usar 'pipeline/automations' como endpoint base e habilitar account scoped
    super('pipeline/automations', { accountScoped: true });
  }

  // Métodos CRUD básicos - o account_id será inserido automaticamente pela classe pai

  async get() {
    const response = await axios.get(this.url);
    return response;
  }

  async show(id) {
    const response = await axios.get(`${this.url}/${id}`);
    return response;
  }

  async create(data) {
    const response = await axios.post(this.url, {
      pipeline_automation: data,
    });
    return response;
  }

  async update(id, data) {
    const response = await axios.patch(`${this.url}/${id}`, {
      pipeline_automation: data,
    });
    return response;
  }

  async destroy(id) {
    const response = await axios.delete(`${this.url}/${id}`);
    return response;
  }

  // Execute automation manually
  async execute(id, context = {}) {
    const response = await axios.post(`${this.url}/${id}/execute`, context);
    return response;
  }

  // Duplicate an automation
  async duplicate(id) {
    const response = await axios.post(`${this.url}/${id}/duplicate`);
    return response;
  }

  // Export automation as JSON
  async exportAutomation(id) {
    const response = await axios.get(`${this.url}/${id}/export`);
    return response;
  }

  // Import automation from JSON
  async importAutomation(data) {
    const response = await axios.post(`${this.url}/import`, {
      automation: data,
    });
    return response;
  }

  // Get automation statistics
  async stats(id) {
    const response = await axios.get(`${this.url}/${id}/stats`);
    return response;
  }

  // Get executions for an automation
  async executions(id, params = {}) {
    const response = await axios.get(`${this.url}/${id}/executions`, {
      params,
    });
    return response;
  }

  // Get all executions across automations
  async allExecutions(params = {}) {
    const response = await axios.get(`${this.url}/all_executions`, { params });
    return response;
  }

  // Validate automation flow
  async validate(id) {
    const response = await axios.post(`${this.url}/${id}/validate`);
    return response;
  }

  // Validate flow without saving
  async validateFlow(flow) {
    const response = await axios.post(`${this.url}/validate_flow`, { flow });
    return response;
  }

  // Dry-run simulation
  async dryRun(id, context = {}) {
    const response = await axios.post(`${this.url}/${id}/dry_run`, context);
    return response;
  }

  // Get dashboard statistics
  async dashboard() {
    const response = await axios.get(`${this.url}/dashboard`);
    return response;
  }
}

export default new PipelineAutomationsAPI();
